import api from './api'
import API_URLS from '~/core/api-urls'
import { logError } from '~/core/logger'

export const fetchPersonalRoom = () =>
  api.get(API_URLS.personalConference)

export const fetchValidRoomInfo = input =>
  api.post(API_URLS.roomUrl, { url: input })

export const fetchPersonalRoomInvite = async () => {
  const resp = await api.get(API_URLS.personalConferenceInvite, {
    headers: {
      Accept: 'text/plain'
    }
  })
  if (api.isErrorResponse(resp)) {
    return null
  }

  return resp
}

export const fetchMeetingDid = roomName =>
  fetchValidRoomInfo(roomName)
    .then(result => {
      if (api.isErrorResponse(result)) {
        throw new Error('Unable to get room info')
      }
      return api.get(API_URLS.sessionInvite(result.conference))
    })
    .then(roomInfo => {
      if (api.isErrorResponse(roomInfo)) {
        throw new Error('Unable to get meeting DID')
      }
      return roomInfo.promoteCallRoutingDid
    })
    .catch(err => {
      logError({ __filename, err }, 'Failed getting meeting DID')
      throw err
    })
